//imports
import { all } from 'redux-saga/effects';

//Views
import rawDataTabSagas from 'Modules/rawData/.components/tab/redux/saga';
import deviceReadingSagas from 'Modules/rawData/.components/tab/.components/details/redux/saga';
import videoPlayerSagas from 'Modules/rawData/.components/videoPlayer/redux/saga';
//merge sagas
export default function* rootSaga() {
    yield all([
        rawDataTabSagas(),
        deviceReadingSagas(),
        videoPlayerSagas(),
    ]);
}